module.exports = __webpack_public_path__ + "rate_guide.d2b6f0b20d4ce2941b37fe4ed199af3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/rate_guide.svg
// module id = 343
// module chunks = 0